// Auto-generated entry for article// import './../../article.scss';

// Includes general styles and scripts
import './initial';

import '../js/src/techno.art.detail.helper.js';
import '../js/src/art.article-variations.js';
import '../js/src/te.basket.btn.helper.js';
import '../js/src/art.image-gallery.js';
import '../js/src/art.art-info.js';

import '../js/src/vendor/script/opacc.staticcontent';
import '../js/src/vendor/script/opacc.article';

import '@scss/modules/article.scss';

import TKModuleFactory from '@tk/utilities/tk.module.factory';
import TKCarousel from '@tk/components/tk.carousel';
import TKStaticContent from '@tk/controls/tk.static.content';
import TESelectLink from '@/components/te.select.link';
import TEPrice from '@/components/te.price';

export default class Article extends TKModuleFactory {
    constructor() {
        super([
            { name: 'tk-carousel', constructor: TKCarousel },
            { name: 'te-select-link', constructor: TESelectLink },
            { name: 'tk-static-content', constructor: TKStaticContent },
            { name: 'te-price', constructor: TEPrice },
        ]);
    }
}

new Article();
